import axios from '@/libs/api.request'


export const addPlayAdMaterial = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/play-ad-material/create'
  })
}

export const delPlayAdMaterial = (id) => {
  return axios.request({
    method: 'delete',
    url: '/play-ad-material/delete/' + id
  })
}

export const getPlayAdMaterialList = (data) => {
  return axios.request({
    method: 'post',
    url: '/play-ad-material/list',
    data
  })
}

export const setCurrentPlayAdMaterial = (id) => {
  return axios.request({
    method: 'put',
    url: '/play-ad-material/set-current',
    data: { id }
  })
}

export const updatePlayAdMaterialName = (data) => {
  return axios.request({
    method: 'put',
    url: '/play-ad-material/update-name',
    data
  })
}

export const getFileUploadPresigned = (params) => {
  return axios.request({
    method: 'get',
    url: '/file/upload/presigned',
    params
  })
}

export const confirmFileUploadComplete = (data) => {
  return axios.request({
    method: 'post',
    url: '/file/upload/complete',
    data
  })
}